<div id="page-top"></div>
<app-header></app-header>
<div class="row container-fluid mx-0 px-0" [ngClass]="infoService.darkTheme ? 'dark-theme-background' : 'light-theme-background'">
  <div class="container-md px-0">
    <app-earn-portal [earnPage]="true"></app-earn-portal>
  </div>
</div>